export default "__VITE_ASSET__B19D$4pP__"